import enterpriseAccountBookView from "./EnterpriseAccountBookView";

export default enterpriseAccountBookView;
